module.exports = __webpack_public_path__ + "static/media/img13.909394c4.jpg";